import { useCallback, useState } from "react";
import { useScoreApi, unwrap } from "../api/scoreApi";

// #837 — the Ride Editor re-point tool: move a ride's ScoreSheets onto an
// operator-chosen targetRideId in another class (score-api POST
// /ride/:rideId/repoint, generalized from #388's resolveManualRide). The
// server HARD-BLOCKS with 409 if the target already has ScoreSheets (code
// "target_already_scored") or if any sheet's testId doesn't match the
// target's testId (code "test_mismatch") — all-or-nothing, no partial
// writes. The caller (RidePointer page) already disables an ineligible
// target row client-side; this is the last-line server enforcement in case
// of a race or a bypassed client check.
export function useRepointRide() {
  const scoreApi = useScoreApi();
  const [repointing, setRepointing] = useState(false);

  const repoint = useCallback(
    async (sourceRideId, targetRideId) => {
      setRepointing(true);
      try {
        return unwrap(
          await scoreApi.rides.repointRide(sourceRideId, { targetRideId }),
        );
      } finally {
        setRepointing(false);
      }
    },
    [scoreApi],
  );

  return { repoint, repointing };
}

export default useRepointRide;
